/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 17:08:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-18 16:12:22
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/ProductDetail/tools.ts
 */

import {
  onProductDetailChange,
  onProductDetailOptionsChange,
  ActionType,
} from '../slice';

const useChangeFunctions = ({ detailUuid, dispatch: _d }) => {
  const onDetailAdd = () => {
    _d(
      onProductDetailChange({
        type: ActionType.add,
      }),
    );
  };

  const onDetailDelete = () => {
    _d(
      onProductDetailChange({
        detailUuid,

        type: ActionType.delete,
      }),
    );
  };

  const onRequiredChange = (required) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { required },
        type: ActionType.modify,
      }),
    );
  };

  const onFieldTypeChange = (fieldType) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { fieldType },
        type: ActionType.modify,
      }),
    );
  };

  const onTitleChange = (title) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { title },
        type: ActionType.modify,
      }),
    );
  };

  const onOptionChange = (optionType) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { optionType },
        type: ActionType.modify,
      }),
    );
  };

  const onCharLimitChange = (charLimit) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { charLimit },
        type: ActionType.modify,
      }),
    );
  };

  const onPlaceholderChange = (placeHolder) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { placeHolder },
        type: ActionType.modify,
      }),
    );
  };

  const onMaxSelectionChange = (maxSelection) => {
    _d(
      onProductDetailChange({
        detailUuid,
        value: { maxSelection },
        type: ActionType.modify,
      }),
    );
  };

  const onOptionsChange = ({ index, value }) => {
    _d(
      onProductDetailOptionsChange({
        detailUuid,
        index,
        value,
        type: ActionType.modify,
      }),
    );
  };

  const onOptionsSort = ({ from, to }) => {
    _d(
      onProductDetailOptionsChange({
        detailUuid,
        from,
        to,
        type: ActionType.reorder,
      }),
    );
  };

  const onOptionsDelete = ({ index }) => {
    _d(
      onProductDetailOptionsChange({
        detailUuid,
        index,
        type: ActionType.delete,
      }),
    );
  };

  const onOptionsAdd = () => {
    _d(onProductDetailOptionsChange({ detailUuid, type: ActionType.add }));
  };

  return {
    onRequiredChange,
    onFieldTypeChange,
    onTitleChange,
    onOptionChange,
    onMaxSelectionChange,
    onOptionsChange,
    onOptionsSort,
    onOptionsDelete,
    onOptionsAdd,
    onCharLimitChange,
    onPlaceholderChange,
    onDetailAdd,
    onDetailDelete,
  };
};
export { useChangeFunctions };
